import { render, staticRenderFns } from "./ViewResellerServicePage.vue?vue&type=template&id=611d624a"
import script from "./ViewResellerServicePage.vue?vue&type=script&lang=js"
export * from "./ViewResellerServicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports